import { html } from 'htm/preact'

export interface FaqItem {
    question:string
    answer:string|ReturnType<typeof html>
}

export const FAQ_ITEMS:FaqItem[] = [
    {
        question: 'How does offline mode work?',
        answer: 'Every transaction is saved to your device first. ' +
            'When an internet connection is available, hvaclog syncs ' +
            'automatically. You never need to think ' +
            'about connectivity. Basements, rooftops, and remote sites ' +
            'all behave the same as a full-signal location.'
    },
    {
        question: 'Does hvaclog make me EPA-compliant?',
        answer: 'hvaclog is a recordkeeping tool. ' +
            'It helps you capture and organize the data that ' +
            'EPA Section 608 requires you to maintain, like transaction dates, ' +
            'refrigerant type, quantities, system identifiers, and ' +
            'technician. ' +
            'Consult a qualified professional for ' +
            'compliance advice specific to your shop.'
    },
    {
        question: 'Who owns my data, and can I export it?',
        answer: 'You own your data. You can export a complete PDF ' +
            'refrigerant log for any date range at any time. No ' +
            'support ticket required. If you ever cancel, your data ' +
            'remains exportable for 90 days after your subscription ends.'
    },
    {
        question: 'What are the free tools?',
        answer: html`The free tools are a set of standalone HVAC calculators
            available at <a href="/tools">/tools</a>, including refrigerant
            charge calculators, superheat and subcooling tools, PT charts,
            and more. They require no account and have no usage limit.
            They are separate from the paid refrigerant log app.`
    },
    {
        question: 'How does billing work?',
        answer: 'The monthly plan is billed at $149 per month and can be ' +
            'cancelled any time. The lifetime founding deal is a single ' +
            'payment of $1,499 with no recurring charges. Both plans ' +
            'cover your whole shop. There are no per-technician or ' +
            'per-device fees. Payment is handled securely in the app.'
    },
    {
        question: 'Is there a free trial?',
        answer: 'Yes. New accounts get 14 days of full access, free. ' +
            'We collect a card when you start so nothing breaks when the ' +
            'trial ends. Do nothing and your trial converts to the ' +
            'Monthly plan at $149/month on day 15. Prefer the lifetime ' +
            'founding deal? Choose it any time during the trial. Cancel ' +
            "before day 14 and you won't be charged."
    },
    {
        question: 'How do I cancel?',
        answer: 'Monthly subscribers can cancel from the billing section ' +
            'of the app at any time. Cancellation takes effect at the ' +
            'end of the current billing period. You keep access until ' +
            'then. Lifetime plan holders are not billed again and have ' +
            'nothing to cancel.'
    }
]
